module.exports = __webpack_public_path__ + "img/activesuite13.d785d43d.jpg";